/** Step 2/4 — banned words (≤50) + signature phrases (≤20) per AI-09 §C1/§G2. */
import { useTranslation } from "react-i18next";

import { ChipsInput } from "../ChipsInput";
import type { StepProps } from "./ToneStep";

export function WordsStep({ draft, update }: StepProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <div>
        <p className="mb-2 text-sm text-neutral-600">{t("brandVoice.words.banned_question")}</p>
        <ChipsInput
          id="voice-banned-words"
          label={t("brandVoice.words.banned_label")}
          value={draft.banned_words ?? []}
          onChange={(banned_words) => update({ banned_words })}
          maxItems={50}
          maxLength={50}
          placeholder={t("brandVoice.words.banned_placeholder")}
          limitHint={t("brandVoice.words.banned_limit")}
          removeLabel={(chip) => t("brandVoice.words.remove", { item: chip })}
        />
      </div>
      <div>
        <p className="mb-2 text-sm text-neutral-600">{t("brandVoice.words.phrases_question")}</p>
        <ChipsInput
          id="voice-signature-phrases"
          label={t("brandVoice.words.phrases_label")}
          value={draft.signature_phrases ?? []}
          onChange={(signature_phrases) => update({ signature_phrases })}
          maxItems={20}
          maxLength={200}
          placeholder={t("brandVoice.words.phrases_placeholder")}
          limitHint={t("brandVoice.words.phrases_limit")}
          removeLabel={(chip) => t("brandVoice.words.remove", { item: chip })}
        />
      </div>
    </div>
  );
}
